import React from "react";
import styles from "../../../style/layout_components/Step1.module.scss";
import NumberInput from "../../InputFields/NumberInput";
import SliderInput from "../../InputFields/SliderInput";
import HorizontalRadioInput from "../../InputFields/HorizontalRadioInput";
import { currencyThousandFormat } from "../../InputFields/sanitizer/currencyFormat";
import { roundValueOffset } from "../../InputFields/sanitizer/roundValueOffset";
import { dupInsuranceProductTypes } from "../../../Enums/enumValues";
import thousandsFormat from "../../InputFields/sanitizer/thousandsFormat";
import { V5, BR208, BR209 } from "../../InputFields/validator/validators";
import { Text } from "@sitecore-jss/sitecore-jss-react";

function DupVariantCoverage({
  data,
  defaultCoverage,
  insuredAmounts,
  index,
  fieldData,
  modelState,
  setModelState,
  updateInsuredCoverage,
  updateInsuredCoverageInsuranceType,
  updateInsuredCoverageInsuredAmount,
  expand,
  setExpand,
}) {
  const dupInsuranceTypes = dupInsuranceProductTypes();
  const step = 100;
  if (defaultCoverage.insuranceType === "PurchaseMoneyProduct") {
    delete dupInsuranceTypes[0];
    delete dupInsuranceTypes[1];
  } else {
    delete dupInsuranceTypes[2];
  }
  const validationPropertyName = `model.Insured[${index}].PersonCoverage`;
  const isServiceInsuranceChoosen = defaultCoverage.insuranceType === "ServicesProduct";
  return (
    <tr className={expand ? styles.coverageIsOpen : styles.coverage}>
      <td colSpan="2">
        <div className={styles.coverageContent}>
          <HorizontalRadioInput
            fieldData={fieldData}
            selectedValue={data.insuranceType}
            modelState={modelState}
            setModelState={setModelState}
            options={dupInsuranceTypes}
            propertyName={`${validationPropertyName}.InsuranceType`}
            name="InsuranceType"
            onChange={updateInsuredCoverageInsuranceType}
            fieldName={`InsuranceType${index}`}
          />
          <NumberInput
            id={`input_insuredamount_${index}`}
            fieldData={fieldData}
            name={isServiceInsuranceChoosen ? "InsuranceServiceAmount" : "InsuranceMoneyAmount"}
            inputValue={data.insuredAmount || ""}
            sanitize={thousandsFormat}
            onChange={updateInsuredCoverageInsuredAmount}
            modelState={modelState}
            setModelState={setModelState}
            validators={[V5, BR208(insuredAmounts.maxAmount), BR209(insuredAmounts.minAmount)]}
            propertyName={`${validationPropertyName}.InsuredAmount`}
          />
          <SliderInput
            id={`slider_${index}`}
            fieldData={fieldData}
            inputValue={data.insuredAmount}
            modelState={modelState}
            setModelState={setModelState}
            onChange={updateInsuredCoverageInsuredAmount}
            min={insuredAmounts.minAmount}
            max={insuredAmounts.maxAmount}
            step={step}
            dynamicMinLabel={currencyThousandFormat(insuredAmounts.minAmount)}
            dynamicMaxLabel={currencyThousandFormat(insuredAmounts.maxAmount)}
            defaultInputValue={insuredAmounts.minAmount}
            sanitize={[roundValueOffset(step, insuredAmounts.minAmount, insuredAmounts.maxAmount)]}
          />
        </div>
        <div className="button-container button-container--flex-end">
          <button
            className="link"
            id={`button_use_standard_${index}`}
            onClick={() => {
              updateInsuredCoverage(
                { insuranceType: defaultCoverage.insuranceType, insuredAmount: defaultCoverage.insuredAmount },
                false
              );
              setExpand(false);
            }}
          >
            <Text field={fieldData.UseDefaultCoverageButtonText}></Text>
          </button>
          {fieldData.EditButtonText.value && (
            <button
              id={`button_modify_coverage_${index}`}
              className="tertiary"
              onClick={() => {
                updateInsuredCoverage(data, true);
                setExpand(false);
              }}
            >
              <span>
                <i className="icon icon-check"></i> <Text field={fieldData.EditButtonText}></Text>
              </span>
            </button>
          )}
        </div>
      </td>
    </tr>
  );
}

export default DupVariantCoverage;
